const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKontaktpersonBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "kontaktperson",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167.81 223.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "a74bce50-4f29-4c47-ada7-3e54e62a4d94",
    "data-name": "border",
    d: "M55.4,4.48c6.74,2.14,8,21.86,8.46,27.64s17.85,8.64,17.85,8.64S90.87,35.18,94,34s3.72-11.61,3.47-18.49,8.35-17.19,23.58-15,11.44,22.05,9.82,25.51,8.84,6.42,12.52,12.38,11.05,17.86,13,29.16-.28,26.4-.28,26.4L167,93.84l.55,28.88s-7.86-.81-9.09.29-5.46,8-7.66,9.58-8.6,2.54-10,8.19-2.49,16.95-4.21,19.46-4.18,20.82-4.26,27.48,8.68,24,8.47,30.17-11.09,3.69-15.07,2.46-17.38,0-26.23,0-4.91-6.14-7.43-10.64-16.88.32-19.33,2.5-17,.53-22.67.51-7.79,7.38-11.54,9.59-13.44-.24-16.63-1.72-1-7.61,0-10.88-1.23-15.64-.74-23.5,3.35-29.31,3.33-37c0-8.55-1.41-23.69-1.41-23.69a34.7,34.7,0,0,0-7.32-1.83,70.86,70.86,0,0,1-7.48-1.29h-8v-28H10.41s4.57-37.89,8-44.52S28.49,38.87,32.08,36.65s1.08-9.08.7-14.7S33.89,8.41,35.9,5.58C35.9,5.58,39.5-.55,55.4,4.48Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKontaktpersonBorder);
export default __webpack_public_path__ + "static/media/kontaktperson-border.466268636b785b441b2218882b69620f.svg";
export { ForwardRef as ReactComponent };